export const getErrorMessage = (error: any): string => {
  if (!error?.status) return 'An unexpected error occurred. Please contact a developer';

  if (error.data?.message) return `Error ${error.status}: ${error.data.message}`;
  if (error.data?.error) return `Error ${error.status}: ${error.data.error}`;
  if (error.data?.name?.[0]) return `Error ${error.status}: ${error.data.name[0]}`;

  return 'An unexpected error occurred. Please contact a developer';
};